module.exports = __webpack_public_path__ + "img/new_index_industry_icon2.4ba1cbd2.png";